// extracted by mini-css-extract-plugin
module.exports = {"excludedWords":"excludedWords__Lldn8"};